<template>
    <div class="verify_page page">
        <div class="top_bg">
            <!--      <img src="../assets/verify_bg.png">-->
            <img :src="banner?api+banner:require('../assets/download_bg.png')">
        </div>

        <b-container class="verify_content my_content">
            <p class="title">产品验证</p>

            <div class="one">
                <p class="title">第一步</p>
                <p>操作指南：找到包装上的防伪标签，刮开涂层后，关注【AIRDISK】官方公众号，在公众号菜单中进行防伪查询，或者输入防伪码查询。</p>
                <img src="../assets/verify3.png" alt="">
                <!--        <p>2.新的防伪标签，找到包装上的防伪标签，刮开涂层后，关注【雷克沙Lexar】官方公众号，在公众号菜单中进行防伪查询，或者输入防伪码查询。</p>-->
                <!--        <img src="../assets/verify2.png" alt="">-->
            </div>

            <div class="one">
                <p class="title">第二步</p>
                <p class="sub">将产品防伪码填入下框点击确认</p>
                <b-form-input class="input1" placeholder="防伪码" v-model="value"></b-form-input>
                <div class="input2_box">
                    <b-form-input class="input2 left" placeholder="验证码" v-model="code"></b-form-input>
                    <span class="code" @click="rand(1000,9999)">{{ randNum }}</span>
                </div>

                <div class="more_box">
                    <div class="more_btn" @click="submit()">
                        提交
                    </div>
                </div>
            </div>

            <div class="remind">
                <p class="title">温馨提示</p>
                <p>请刮开防伪标签涂层后，获取防伪码进行真伪查询。</p>
                <p>
                    若您收到的产品未附防伪标签，请勿担心，可向购买经销商或AIRDISK售后服务中心咨询（电话：400-601-5156）。
                </p>
            </div>
        </b-container>
        <b-alert class="alert" :variant="result.errorCode==200?'success':'danger'" v-model="showDismissibleAlert">
            {{ result.msg }}
        </b-alert>
    </div>
</template>

<script>
    import {api} from '../api/api';

    export default {
        name: "Verify",
        data() {
            return {
                value: '',
                ip: '',
                showDismissibleAlert: false,
                result: {},
                title: '',
                banner: '',
                randNum: '',
                code: '',
                api: api
            }
        },
        methods: {
            rand(min, max) {
                this.randNum = Math.floor(Math.random() * (max - min)) + min;
            },

            getUserIP(onNewIP) {
                let MyPeerConnection = window.RTCPeerConnection || window.mozRTCPeerConnection || window.webkitRTCPeerConnection;
                let pc = new MyPeerConnection({
                    iceServers: []
                });
                let noop = () => {
                };
                let localIPs = {};
                let ipRegex = /([0-9]{1,3}(\.[0-9]{1,3}){3}|[a-f0-9]{1,4}(:[a-f0-9]{1,4}){7})/g;
                let iterateIP = (ip) => {
                    if (!localIPs[ip]) onNewIP(ip);
                    localIPs[ip] = true;
                };
                pc.createDataChannel('');
                pc.createOffer().then((sdp) => {
                    sdp.sdp.split('\n').forEach(function (line) {
                        if (line.indexOf('candidate') < 0) return;
                        line.match(ipRegex).forEach(iterateIP);
                    });
                    pc.setLocalDescription(sdp, noop, noop);
                }).catch((reason) => {
                    console.log(reason)
                });
                pc.onicecandidate = (ice) => {
                    if (!ice || !ice.candidate || !ice.candidate.candidate || !ice.candidate.candidate.match(ipRegex)) return;
                    ice.candidate.candidate.match(ipRegex).forEach(iterateIP);
                };
            },

            submit() {
                let self = this;

                if (this.randNum != this.code) {
                    this.result = {
                        errorCode: 500,
                        msg: '验证码错误'
                    }
                    self.showDismissibleAlert = true;
                    setTimeout(() => {
                        self.showDismissibleAlert = false;
                    }, 3000)
                    return;
                }

                var xhr = new XMLHttpRequest();
                let data = new FormData();
                data.append('code', this.value);
                data.append('ip', this.ip ? this.ip : '47.106.75.130');
                data.append('Brand', 'AIRDISK');

                xhr.open('POST', 'https://cloud.longsys.com/guard/sn/open/query/code', false);
                xhr.onreadystatechange = function () {
                    console.log(xhr)
                    if (xhr.readyState == 4) {
                        if (xhr.status == 200 || xhr.status == 304) {
                            self.result = JSON.parse(xhr.responseText)
                            self.showDismissibleAlert = true;
                            setTimeout(() => {
                                self.showDismissibleAlert = false;
                            }, 3000)
                        }
                    }
                }

                xhr.send(data);

            }
        },
        mounted() {
            this.rand(1000, 9999)

            let menuList = JSON.parse(window.localStorage.getItem('menuList'));
            for (let i = 0; i < menuList.length; i++) {
                if (menuList[i].children) {
                    for (let j = 0; j < menuList[i].children.length; j++) {
                        if (this.$route.path.indexOf(menuList[i].children[j].menuUrl) > 0) {
                            this.title = menuList[i].children[j].title
                            this.banner = menuList[i].children[j].banner
                        }
                    }
                }
            }

            this.getUserIP((ip) => {
                this.ip = ip;
                console.log(this.ip)
            });
        }
    }
</script>

<style scoped lang="scss" src="../css/verify.scss">

</style>